import React from 'react'
import SelectTableFilter from 'components/atoms/select-table-filter'
import TimeUtil from 'utils/time-util'
import RowButton from 'components/atoms/row-button'
import PhotoStudioReceiveBadge from 'domains/merchant-inventory-batch-item/atoms/photo-studio-receive-badge'
import PhotographyStatusBadge from 'domains/merchant-inventory-batch-item/atoms/photography-status-badge'
import PutAwayStatusBadge from 'domains/merchant-inventory-batch-item/atoms/put-away-status-badge'
import PhotoEditedStatusBadge from 'domains/merchant-product/atoms/photo-edited-status-badge'
import PhotoUploadStatusBadge from 'domains/merchant-product/atoms/photo-upload-status-badge'
import { PHOTO_RECEIVED_STATUS } from 'domains/merchant-inventory-batch-item/constants'
import {
  PHOTO_UPLOAD_STATUS,
  PHOTOGRAPHY_STATUS,
  PHOTO_EDITED_STATUS
} from 'domains/merchant-product/constants'
/**
 * Merchant Inventory Batch Item Table Columns
 * column for inventory item with photo_received_status === 'pending'
 *
 */
const merchantInventoryBatchItemTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick,
  isButtonDisabled
}) => {
  // eslint-disable-next-line react/prop-types
  const PhotoUploadStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_UPLOAD_STATUS).map((key) => (
      {
        label : PHOTO_UPLOAD_STATUS[key],
        value : PHOTO_UPLOAD_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const PhotographyStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTOGRAPHY_STATUS).map((key) => (
      {
        label : PHOTOGRAPHY_STATUS[key],
        value : PHOTOGRAPHY_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const PhotoEditedStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_EDITED_STATUS).map((key) => (
      {
        label : PHOTO_EDITED_STATUS[key],
        value : PHOTO_EDITED_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const PhotoReceivedStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_RECEIVED_STATUS).map((key) => (
      {
        label : PHOTO_RECEIVED_STATUS[key],
        value : PHOTO_RECEIVED_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const PhotoReceivedCell = (row) => <PhotoStudioReceiveBadge photo_received_status={ row.cell.value } />
  const PhotographyCell   = (row) => <PhotographyStatusBadge photographyStatus={ row.cell.value } />
  const PutAwayCell       = (row) => <PutAwayStatusBadge putAwayStatus={ row.cell.value } />
  const PhotoEditedCell   = (row) => <PhotoEditedStatusBadge photoEditedStatus={ row.cell.value } />
  const PhotoUploadCell   = (row) => <PhotoUploadStatusBadge photoUploadStatus={ row.cell.value } />

  const TextWrapCell = (row) => <div className='text-wrap'>{ row.cell.value }</div>

  const DateCell = (row) => TimeUtil.format(row.cell.value)

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {
    // eslint-disable-next-line react/prop-types
    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        // eslint-disable-next-line react/prop-types
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        text={ buttonText }
        disabled={ disabled }
      />
    )

  }

  return (
    [
      {
        Header   : <>Inventory<br/>SKU</>,
        accessor : 'sku',
        maxWidth : 90
      },
      {
        Header         : 'Product name',
        accessor       : 'merchant_product.name',
        id             : 'product_name',
        Cell           : TextWrapCell,
        disableFilters : true
      },
      {
        Header         : 'Size',
        accessor       : 'inbound_item.merchant_product_variant.size',
        id             : 'size',
        disableFilters : true
      },
      {
        Header         : <>Qty <br/>Avail</>,
        accessor       : 'quantity',
        disableFilters : true
      },
      {
        Header         : <>Qty <br/>Put <br/>Away</>,
        accessor       : 'quantity_put_away',
        disableFilters : true
      },
      {
        Header         : <>Qty <br/>Reject</>,
        accessor       : 'inbound_item.quantity_rejected',
        id             : 'quantity_rejected',
        disableFilters : true
      },
      {
        Header         : <>Put Away<br/> Date</>,
        accessor       : 'put_away_date',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header         : <>Put <br/>Away<br/> By</>,
        id             : 'put_away_by',
        accessor       : 'put_away_by.name',
        disableFilters : true
      },
      {
        Header         : <>Put Away <br/>Status</>,
        accessor       : 'put_away_status',
        Cell           : PutAwayCell,
        disableFilters : true
      },
      {
        Header   : <>Photo Upload <br/>Status</>,
        accessor : 'merchant_product.photo_upload_status',
        id       : 'photo_upload_status',
        Cell     : PhotoUploadCell,
        Filter   : PhotoUploadStatusFilter
      },
      {
        Header         : <>Photo<br/> Receive<br/> Date</>,
        accessor       : 'photo_received_date',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header         : <>Photo<br/> Receive<br/> By</>,
        accessor       : 'photo_received_by.name',
        id             : 'photo_received_by',
        disableFilters : true
      },
      {
        Header   : <>Photo Studio <br/>Received Status</>,
        accessor : 'photo_received_status',
        Cell     : PhotoReceivedCell,
        Filter   : PhotoReceivedStatusFilter

      },
      {
        Header         : <>Photo<br/>Taken<br/> Date</>,
        accessor       : 'merchant_product.photography_date',
        id             : 'photography_date',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header         : <>Photo<br/>Taken<br/> By</>,
        id             : 'photography_by',
        accessor       : 'photography_by.name',
        disableFilters : true
      },
      {
        Header   : <>Photography <br/>Status</>,
        accessor : 'merchant_product.photography_status',
        id       : 'photography_status',
        Cell     : PhotographyCell,
        Filter   : PhotographyStatusFilter
      },
      {
        Header         : <>Photo<br/> Edited <br/>Date</>,
        accessor       : 'merchant_product.photo_edited_date',
        id             : 'photo_edited_date',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header         : <>Photo<br/> Edited<br/> By</>,
        id             : 'photo_edited_by',
        accessor       : 'photo_edited_by.name',
        disableFilters : true
      },
      {
        Header   : <>Photo Edited <br/>Status</>,
        accessor : 'merchant_product.photo_edited_status',
        id       : 'photo_edited_status',
        Cell     : PhotoEditedCell,
        Filter   : PhotoEditedStatusFilter
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default merchantInventoryBatchItemTableColumns
